<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>CMS Blog</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">CMS Blog</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="CMSBlog">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{ name: 'CMSBlogList' }"
                  ><i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-8">
                  <el-tabs type="border-card" v-model="activeTabName">
                    <el-tab-pane label="Basic" name="Basic">
                      <div class="form-group required">
                        <label class="control-label">Title</label>
                        <input
                          type="text"
                          id="blog_title"
                          name="blog_title"
                          v-bind:class="{
                            'has-error': errors.has('blog_title'),
                          }"
                          v-validate="'required'"
                          v-model="value.blog_title"
                          class="form-control blog_title"
                          placeholder="Title"
                        />
                        <div
                          class="help text-danger"
                          v-show="errors.has('blog_title')"
                        >
                          {{ errors.first("blog_title") }}
                        </div>
                      </div>
                      <div class="form-group required">
                        <label class="control-label">Slug URL</label>
                        <input
                          type="text"
                          id="blog_slug"
                          name="blog_slug"
                          v-bind:class="{
                            'has-error': errors.has('blog_slug'),
                          }"
                          v-validate="'required'"
                          v-model="value.blog_slug"
                          class="form-control blog_slug"
                          placeholder="Slug URL"
                        />
                        <div
                          class="help text-danger"
                          v-show="errors.has('blog_slug')"
                        >
                          {{ errors.first("blog_slug") }}
                        </div>
                      </div>
                      <div class="form-group required">
                        <label class="control-label">Category</label>
                        <multiselect
                          id="blog_category_id"
                          name="blog_category_id"
                          :options="Object.keys(pre.blog_category_id)"
                          :custom-label="(opt) => pre.blog_category_id[opt]"
                          v-bind:class="{
                            'has-error': errors.has('blog_category_id'),
                          }"
                          v-validate="'required'"
                          v-model="value.blog_category_id"
                          class="blog_category_id"
                          placeholder="Select Category"
                          :searchable="true"
                          :close-on-select="true"
                          :show-labels="false"
                        ></multiselect>
                        <div
                          class="help text-danger"
                          v-show="errors.has('blog_category_id')"
                        >
                          {{ errors.first("blog_category_id") }}
                        </div>
                      </div>
                      <div class="form-group required">
                        <label class="control-label">Blog Subcategory</label>
                        <multiselect
                          id="blog_subcategory_id"
                          name="blog_subcategory_id"
                          :options="Object.keys(pre.blog_subcategory_id)"
                          :custom-label="(opt) => pre.blog_subcategory_id[opt]"
                          v-bind:class="{
                            'has-error': errors.has('blog_subcategory_id'),
                          }"
                          v-validate="'required'"
                          v-model="value.blog_subcategory_id"
                          class="blog_subcategory_id"
                          placeholder="Select Blog Subcategory"
                          :searchable="true"
                          :close-on-select="true"
                          :show-labels="false"
                        ></multiselect>
                        <div
                          class="help text-danger"
                          v-show="errors.has('blog_subcategory_id')"
                        >
                          {{ errors.first("blog_subcategory_id") }}
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="control-label">Summary</label>
                        <textarea
                          id="blog_summary"
                          name="blog_summary"
                          v-model="value.blog_summary"
                          class="form-control blog_summary"
                          placeholder="Summary"
                          rows="3"
                        ></textarea>
                      </div>
                      <div class="form-group">
                        <label class="control-label">Content</label>
                        <ckeditor
                          value=""
                          d="blog_content"
                          name="blog_content"
                          v-model="value.blog_content"
                          class="page_content"
                        ></ckeditor>
                        <!--                        <textarea id="blog_content" name="blog_content"


                                  v-model="value.blog_content" class="form-control blog_content"
                                  placeholder="Content"
                                  rows="3"></textarea>-->
                      </div>
                      <div class="col-md-12">
                        <h4 class="site-heading my-3">
                          <span>Blog Featured Image</span>
                        </h4>
                      </div>
                      <div class="form-group col-md-12">
                        <label for="blog_featured_image"></label>
                        <div class="row align-items-center">
                          <div class="col-4">
                            <div class="input-group">
                              <div class="custom-file">
                                <input
                                  type="file"
                                  name="blog_featured_image"
                                  class="custom-file-input"
                                  id="blog_featured_image"
                                  @change="select_file_blog_featured_image"
                                />
                                <label
                                  class="custom-file-label"
                                  for="blog_featured_image"
                                  >{{ value.blog_featured_image_name }}</label
                                >
                              </div>
                            </div>
                          </div>
                          <div
                            class="form-group"
                            v-if="blog_featured_image_temp"
                          >
                            <img
                              alt="preview image"
                              :src="blog_featured_image_temp"
                              width="100"
                              height="100"
                              class="img-circle"
                            />
                            {{ value.blog_featured_image_name }}
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="control-label">Tagline</label>
                        <input
                          type="text"
                          id="blog_tagline"
                          name="blog_tagline"
                          v-model="value.blog_tagline"
                          class="form-control blog_tagline"
                          placeholder="Tagline"
                        />
                      </div>
                      <!--                      <div class="form-group ">
                        <label class="control-label">View Count</label>
                        <input type="text" id="view_count" name="view_count"


                               v-model="value.view_count" class="form-control view_count"
                               placeholder="View Count">

                      </div>-->

                      <div class="form-group">
                        <label class="control-label">Blog Tags</label>
                        <multiselect
                          id="blog_tages"
                          name="blog_tages"
                          :options="Object.values(pre.blog_tags)"
                          :custom-label="(opt) => opt"
                          v-bind:class="{
                            'has-error': errors.has('blog_tages'),
                          }"
                          v-model="value.blog_tages"
                          class="blog_tages"
                          :multiple="true"
                          placeholder="Select Tag"
                          :searchable="true"
                          :show-labels="false"
                        ></multiselect>
                      </div>
                      <div class="form-group">
                        <label class="control-label">Status</label>
                        <select
                          class="form-control"
                          style="width: 100%"
                          name="status"
                          v-model="value.status"
                          id="status"
                        >
                          <option value="Active">Active</option>
                          <option value="Inactive">Inactive</option>
                        </select>
                      </div>
                    </el-tab-pane>
                    <el-tab-pane label="SEO" name="SEO">
                      <div class="form-group">
                        <label class="control-label">Blog SEO Title</label>
                        <input
                          type="text"
                          id="blog_seo_title"
                          name="blog_seo_title"
                          v-model="value.blog_seo_title"
                          class="form-control blog_seo_title"
                          placeholder="Blog SEO Title"
                        />
                      </div>
                      <div class="col-md-12">
                        <h4 class="site-heading my-3">
                          <span>SEO Image</span>
                        </h4>
                      </div>
                      <div class="form-group col-md-12">
                        <label for="blog_seo_image"></label>
                        <div class="row align-items-center">
                          <div class="col-4">
                            <div class="input-group">
                              <div class="custom-file">
                                <input
                                  type="file"
                                  name="blog_seo_image"
                                  class="custom-file-input"
                                  id="blog_seo_image"
                                  @change="select_file_blog_seo_image"
                                />
                                <label
                                  class="custom-file-label"
                                  for="blog_seo_image"
                                  >{{ value.blog_seo_image_name }}</label
                                >
                              </div>
                            </div>
                          </div>
                          <div class="form-group" v-if="blog_seo_image_temp">
                            <img
                              alt="preview image"
                              :src="blog_seo_image_temp"
                              width="100"
                              height="100"
                              class="img-circle"
                            />
                            {{ value.blog_seo_image_name }}
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="control-label">SEO Summary</label>
                        <textarea
                          id="blog_seo_summary"
                          name="blog_seo_summary"
                          v-model="value.blog_seo_summary"
                          class="form-control blog_seo_summary"
                          placeholder="SEO Summary"
                          rows="3"
                        ></textarea>
                      </div>
                      <div class="form-group">
                        <label class="control-label">SEO Keywords</label>
                        <input
                          type="text"
                          id="blog_seo_keywords"
                          name="blog_seo_keywords"
                          v-model="value.blog_seo_keywords"
                          class="form-control blog_seo_keywords"
                          placeholder="SEO Keywords"
                        />
                      </div>
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" v-if="!is_edit" class="btn btn-primary">
                Submit
              </button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { DepartmentsAPI, CommonAPI } from "@/services/api";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";

export default {
  name: "CMSBlogForm",
  metaInfo: {
    title: "CMS Blog | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},
    activeTabName: "Basic",
    value: {
      blog_featured_image: "",
      blog_featured_image_name: "Choose file",
      blog_seo_image: "",
      blog_seo_image_name: "Choose file",
    },
    blog_featured_image_temp: "",
    blog_seo_image_temp: "",
    pre: {
      blog_category_id: {},
      blog_subcategory_id: {},
      blog_tags: {},
    },
  }),
  methods: {
    select_file_blog_featured_image: function (event) {
      try {
        let reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = () => {
          this.blog_featured_image_temp = reader.result;
          this.value.blog_featured_image = reader.result;
          this.value.blog_featured_image_name = event.target.files[0].name;
        };
      } catch (e) {
        //console.log(e);
      }
    },

    select_file_blog_seo_image: function (event) {
      try {
        let reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = () => {
          this.blog_seo_image_temp = reader.result;
          this.value.blog_seo_image = reader.result;
          this.value.blog_seo_image_name = event.target.files[0].name;
        };
      } catch (e) {
        //console.log(e);
      }
    },

    blogCategoryIdOptions: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("/get-dropdown-options/6")
          .then((response) => {
            resolve(response.data);
            //return response.data;
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    blogSubcategoryIdOptions: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("/get-dropdown-options/7")
          .then((response) => {
            resolve(response.data);
            //return response.data;
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },

    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/cms_blogs";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/cms_blogs/" + _this.$route.params.id;
            method = "PUT";
          }
          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "CMSBlogList" });
            })
            .catch((errors) => {
              if (errors.response.status === 500) {
                _this.$toaster.error(errors.response.data.message);
              }
              _this.$setErrorsFromResponse(errors.response.data);
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/cms_blogs/" + id;
        axios
          .get(api_url)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    blogTagOptions: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("/cms_blog_tags/get-all")
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;
      await this.blogCategoryIdOptions().then((blog_category_id) => {
        this.pre.blog_category_id = blog_category_id;
      });
      await this.blogSubcategoryIdOptions().then((blog_subcategory_id) => {
        this.pre.blog_subcategory_id = blog_subcategory_id;
      });
      await this.blogTagOptions().then((blogTags) => {
        this.pre.blog_tags = blogTags;
      });

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;

            if (response.data.blog_featured_image) {
              var filename = response.data.blog_featured_image.split("images/");
              this.blog_featured_image_temp =
                this.API_ASSET_UPLOAD_URL + response.data.blog_featured_image;
              this.value.blog_featured_image_name =
                filename.length > 0 ? filename[1] : "";
            }
            if (response.data.blog_seo_image) {
              var seo_image = response.data.blog_seo_image.split("images/");
              this.blog_seo_image_temp =
                this.API_ASSET_UPLOAD_URL + response.data.blog_seo_image;
              this.value.blog_seo_image_name =
                seo_image.length > 0 ? seo_image[1] : "";
            }
          })
          .catch((error) => {
            console.log(error.response);
          });

        // this.value.blog_featured_image = "";
        // this.value.blog_seo_image = "";
      }

      this.is_loading = false;
    },
  },
  mounted() {
    this.initialize();
  },
};
</script>
